import React, { useState } from 'react'
import moment from 'moment'
import { message, Switch } from 'antd'
import { updateProcessStatus } from '../../../../services/api/apiSku'
import { Link } from 'react-router-dom'

const TableRow = ({ item, reload }) => {
    const { name, stages, partner, is_active, created, updated, _id } = Object.assign({}, item)
    const { name: namePartner } = Object.assign({}, partner)
    const [status, setStatus] = useState(is_active)

    const renderStages = (stages) => {
        if (!stages || stages.length === 0) return '-'

        return stages.map(i => !!i.name && i.name).join(', ')
    }

    const handleUpdateProcessStatus = async (checked) => {
        setStatus(checked)
        try {
            const { data: res } = await updateProcessStatus(_id)
            const { data, success, message: mess } = Object.assign({}, res)

            if (!success) return message.error(mess)

            message.success(`Thay đổi trạng thái quy trình thành công!`)
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <tr className='TableRow' key={`${_id}`}>
            <td>
                {
                    !!name ? name : '-'
                }
            </td>
            <td>{renderStages(stages)}</td>
            <td>
                {namePartner ? namePartner : '-'}
            </td>
            <td>
                <Switch
                    checked={status}
                    onChange={handleUpdateProcessStatus}
                />
            </td>
            <td>
                {created ? moment(created).format('HH:mm DD/MM/YYYY') : '-'}
            </td>
            <td>
                {updated ? moment(updated).format('HH:mm DD/MM/YYYY') : '-'}
            </td>
            <td>
                <Link to={`/production-process/${_id}`} className='ml-3'>
                    <i className="fa fa-edit text-primary fa-lg mr-2" id={`TooltipEdit${_id}`} />
                </Link>
            </td>
        </tr>
    )
}

export default TableRow